import { Menu, Badge } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { menuItems } from './menuItems';
import user from 'redux/user';
import cart from 'redux/cart';

import './index.scss';

const NavMenu = (props) => {
  const location = useLocation();
  const currentUser = useSelector(user.selectors.getCurrentUser);
  /* Lines waiting in the cart, not quantity - the same thing the cart screen
     counts in its own footer. Kept current by every write, since each answers
     with the cart it left behind, and by the one fetch the layout runs. */
  const cartItemCount = useSelector(cart.selectors.getCartItemCount);
  const { t } = useTranslation('header');

  /* This same component is both menus - the horizontal bar on a wide screen and
     the drawer on a narrow one - so the count reaches the client either way. */
  const iconFor = (item) =>
    item.countsCartItems ? (
      <Badge count={cartItemCount} size="small" overflowCount={99} className="nav-menu-cart-badge">
        {item.icon}
      </Badge>
    ) : (
      item.icon
    );

  const renderMenuItems = (item) => {
    switch (item.type) {
      case 'subMenu':
        return (
          <Menu.SubMenu title={t(item.title)} icon={item.icon} key={item.title}>
            {item.items.map((subMenuItem) => renderMenuItems(subMenuItem))}
          </Menu.SubMenu>
        );
      default:
        return (
          <Menu.Item key={item.to} icon={iconFor(item)}>
            <Link to={item.to}>{t(item.title)}</Link>
          </Menu.Item>
        );
    }
  };
  return (
    <Menu selectedKeys={[`${location.pathname}${location.search}`]} {...props}>
      {menuItems
        .filter((item) => (typeof item.hide === 'function' ? !item.hide(currentUser) : !item.hide))
        .map((item) => renderMenuItems(item))}
    </Menu>
  );
};

export default NavMenu;
